// extracted by mini-css-extract-plugin
export default {"search":"index_search__p1o6r"};